import isApplePayCompatible from './isApplePayCompatible';
import type { Api } from '../../api';
import type { ActiveBasketSummaryData } from '../../typings/basket.types';

const getIsApplePayAvailable = async (api: Api, activeBasketSummary: ActiveBasketSummaryData): Promise<boolean> => {
    if (isApplePayCompatible()) {
        const shippingMethods = await api.getShippingMethods(activeBasketSummary.id);
        const categories = new Set(shippingMethods.map(({ shippingCategoryId }) => shippingCategoryId));

        const availableShippingMethods = categories.size > 1 ? [] : shippingMethods;
        if (availableShippingMethods.length > 0) {
            return true;
        }
    }

    return false;
};

export default getIsApplePayAvailable;
